/**
 * Global i18n helper for TypeScript files
 * Provides a global $t function similar to Vue templates
 * Enhanced with flat key support
 */

import { $tf } from './flattener';
import { i18n } from './index';

// Export a global $t function that can be used in .ts files
// Now supports flat keys: 'auth.login.agency' -> 'login.agency'
export const $t = (key: string, ...args: any[]): string => {
	return $tf(key, ...args);
};

// Export other i18n functions if needed
export const $n = (value: number, ...args: any[]): string => {
	return i18n.global.n(value, args as any) as string;
};

export const $d = (value: Date | number, ...args: any[]): string => {
	return i18n.global.d(value, args as any) as string;
};

// Make it available globally (optional - for files that use global $t)
if (typeof window !== 'undefined') {
	(window as any).$t = $t;
	(window as any).$n = $n;
	(window as any).$d = $d;
}
